import { IconButton, InputLabelProps, Stack, Tooltip } from "@mui/material";
import { AlertCircleIcon } from "components/Icon";
import { rem } from "utils";

import { Label } from "./InputLabel.styles";

const InputLabel: React.FC<
  InputLabelProps & { as?: string; helperText?: string; mb?: string }
> = ({ children, as, helperText, mb, ...innerProps }) => (
  <Stack direction="row" columnGap="4px" mb={mb || rem(6)}>
    <Label {...innerProps} as={as as unknown as React.ElementType<unknown>}>
      {children}
    </Label>
    {!!helperText && (
      <Tooltip title={helperText} arrow>
        <IconButton sx={{ padding: 0 }}>
          <AlertCircleIcon sx={{ fontSize: "14px" }} />
        </IconButton>
      </Tooltip>
    )}
  </Stack>
);

export default InputLabel;
